module.exports = __webpack_public_path__ + "img/success.4cb0bc02.png";